import {
    apiRequest,
    punishmentDetail
} from "../../../../../services/adapters/master/punishmentService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", punishmentDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository